import React from "react";

export default function BankList() {
  return (
    <div>
      <p>BankList</p>
    </div>
  );
}
